import { createSlice } from "@reduxjs/toolkit";
import {
    fetchCourseSessionsTableColumnNames,
    fetchAllCourseSessions,
    createCourseSessions,
    updateCourseSessions,
    deleteCourseSessions,
    cancelCourseSessions,
    createAssignmentQuestions,
    deleteAssignmentQuestions,
    fetchQuestionsTableColumnNames,
    createAdditionalAssignmentQuestions,
    deleteAdditionalAssignmentQuestions
} from "./thunk";

const coursesSlice = createSlice({
  name: "sessions",
  initialState: {
    module: {},
    sessions: [],
    tableColumnNames: [],
    questionTableColumnNames: [],
    loading: false,
    loadings: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

    // Fetch Course Sessions Table Column Names
    .addCase(fetchCourseSessionsTableColumnNames.pending, (state) => {
      state.loadings = true;
      state.error = null;
    })
    .addCase(fetchCourseSessionsTableColumnNames.fulfilled, (state, action) => {
      state.loadings = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchCourseSessionsTableColumnNames.rejected, (state, action) => {
      state.loadings = false;
      state.error = action.payload;
    })

    // Fetch Question Table Column Names API
    .addCase(fetchQuestionsTableColumnNames.pending, (state) => {
      // state.QuestionLoading = true;
      state.error = null;
    })
    .addCase(fetchQuestionsTableColumnNames.fulfilled, (state, action) => {
      // state.screenLoading = false;
      state.questionTableColumnNames = action.payload;
    })
    .addCase(fetchQuestionsTableColumnNames.rejected, (state, action) => {
      // state.screenLoading = false;
      state.error = action.payload;
    })

    // Get All Course Sessions
    .addCase(fetchAllCourseSessions.pending, (state) => {
      state.module = {};
      state.sessions = [];
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchAllCourseSessions.fulfilled, (state, action) => {
        const { Sessions, ...Course } = action.payload;
      state.loading = false;
      state.module = Course;
      state.sessions = Sessions;
    })
    .addCase(fetchAllCourseSessions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // Add Course Sessions
    .addCase(createCourseSessions.pending, (state) => {
      state.error = null;
    })
    .addCase(createCourseSessions.fulfilled, (state, action) => {
      // state.sessions = [...action.payload.data, ...state.sessions];
      state.sessions = action.payload.data;
    })
    .addCase(createCourseSessions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Update Course Sessions
    .addCase(updateCourseSessions.pending, (state) => {
      state.error = null;
    })
    .addCase(updateCourseSessions.fulfilled, (state, action) => {
      // state.sessions = action.payload;
       const index = state.sessions.findIndex(
        (item) => item.ID === action.payload.ID
      );

      if (index >= 0) {
        state.sessions[index] = action.payload;
      }

    })
    .addCase(updateCourseSessions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Delete Session
    .addCase(deleteCourseSessions.pending, (state) => {
      state.error = null;
    })
    .addCase(deleteCourseSessions.fulfilled, (state, action) => {
      const deletedIds = action.payload.map((item) => item.ID);

      // Filter out the deleted items
      state.sessions = state.sessions.filter((item) => !deletedIds.includes(item.ID));
    })
    .addCase(deleteCourseSessions.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Cancel Session
    .addCase(cancelCourseSessions.pending, (state) => {
      state.error = null;
    })
    .addCase(cancelCourseSessions.fulfilled, (state, action) => {
      const index = state.sessions.findIndex(
        (item) => item.ID === action.payload.ID
      );

      if (index >= 0) {
        state.sessions[index] = action.payload;
        // toast.success("Updated successfully");
      }
    })
    .addCase(cancelCourseSessions.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(createAssignmentQuestions.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] ;
      
      state.sessions = state.sessions.map((item) => item.ID === updatedSession.SessionID ? {...item, QuestionIDs: updatedSession.QuestionIDs} : item)
    })
    .addCase(createAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(deleteAssignmentQuestions.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] ;

      state.sessions = state.sessions.map((item) => item.ID === updatedSession.SessionID ? {...item, QuestionIDs: updatedSession.QuestionIDs} : item)
    })
    .addCase(deleteAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(createAdditionalAssignmentQuestions.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] ;
      
      state.sessions = state.sessions.map((item) => item.ID === updatedSession.SessionID ? {...item, QuestionIDs: updatedSession.QuestionIDs} : item)
    })
    .addCase(createAdditionalAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })

    .addCase(deleteAdditionalAssignmentQuestions.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] ;

      state.sessions = state.sessions.map((item) => item.ID === updatedSession.SessionID ? {...item, ProblemIDs: updatedSession.ProblemIDs} : item)
    })
    .addCase(deleteAdditionalAssignmentQuestions.rejected, (state, action) => {
      state.error = action.payload;
    })
  },
});

export default coursesSlice.reducer;
